import React, { useState, useEffect } from 'react';
import NewLoading from './components/loading';
import NoPermission from '../components/no-permission';
import { urlToMap } from '@/pages/opinion/utils/url';
import { getReportTicket } from '@/pages/opinion/services';
import { connect, useLocation } from 'umi';
import { useInitBuriedPointInfo } from '@/pages/opinion/operationLog/buriedPoint';
import useReportBuryingPoint from '../hooks/useReportBuryingPoint';
import PresetPointFunc from '@op/operationLog/pages/preset';
import CommonTips from '@/pages/opinion/components/CommonTips';
import TimezoneTips from '@/pages/opinion/components/TimezoneTips';

const Report = (props: any) => {
  const [reportUrl, setReportUrl] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const location = useLocation();

  useInitBuriedPointInfo({
    buriedPoint: PresetPointFunc(location.pathname),
    triggerPagePoint: false,
  });
  useReportBuryingPoint({ ...props });

  useEffect(() => {
    const map = urlToMap(window.location.href);
    const game_code = map.get('game_code');
    const content_url = map.get('content_url');
    const hostName = window.location.hostname;
    if (game_code && content_url) {
      setLoading(true);
      getReportTicket({ game_code, content_url })
        .then(
          (res: any) => {
            // console.log(res);
            setReportUrl(
              hostName?.includes('woa') ? res?.full_url_inner : res?.full_url,
            ); // 域名包含woa是内部地址，reportUrl取full_url_inner
          },
          () => {
            setReportUrl('');
          },
        )
        .finally(() => {
          setLoading(false);
        });
    }
  }, [location]);

  return (
    <NewLoading loading={loading}>
      {reportUrl ? (
        <>
          <CommonTips
            wholeGameInfo={props.wholeGameInfo}
            hasMargin
          ></CommonTips>
          <TimezoneTips
            hasMargin
            wholeGameInfo={props.wholeGameInfo}
          ></TimezoneTips>
          <div
            id="coverbox"
            style={{
              background: 'transparent',
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              width: '100%',
              display: 'none',
            }}
          ></div>
          <iframe
            title="Report"
            src={reportUrl}
            width="100%"
            style={{ height: 'calc(100% - 10px)' }}
          ></iframe>
        </>
      ) : (
        <NoPermission type="error" textCN="未获取到报表信息" />
      )}
    </NewLoading>
  );
};
export default connect((state: any) => {
  const { opinionCommon } = state;

  return {
    listMenu: opinionCommon.listMenu,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(Report);
